export default __webpack_public_path__ + "static/ftn85-webfont-e6d33a080e0a276f6fd9d04de4089f2c.woff2";